;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

// Search impl:
// -- search(value, autocomplete_mode)
// -- if autocomplete_mode == tag, search for groups with tag
// -- if autocomplete_mode == group, search for groups with name
// -- if null, generic search over name, tags, description

export type AutocompleteSearchQueryVariables = {
  searchValue: string
}

/** `result` shape depends on `resultType` (e.g. group vs tag). */
export type AutocompleteSearchNode = {
  result: {
    value?: string
    name?: string
    category?: string
  }
  resultType: string
  score?: number | null
}

export type AutocompleteSearchQueryData = {
  autocompleteSearch?: {
    nodes: AutocompleteSearchNode[]
  } | null
}

const autocompleteSearch = gql`
  query autocompleteSearch($searchValue: String!) {
    autocompleteSearch(first: 5, searchValue: $searchValue) {
      nodes {
        result
        resultType
        score
      }
    }
  }
`
export default autocompleteSearch
